// extracted by mini-css-extract-plugin
export default {"TableLoader":"TableLoaderLight__TableLoader___CR3fU"};